module.exports = __webpack_public_path__ + "img/cpRemoteDebug.547653cb.svg";